






















































































import { Component, Inject, Mixins } from "vue-property-decorator";
import {
  ITicketProvider,
  ITicketProviderMethods
} from "@/models/providers/ticket";
import Context from "@/mixins/context";
import ClientMixin from "@/mixins/clientMixin";

@Component({
  components: {
    "ticket-detail-cell": () =>
      import("@/components/app/global/tickets/ticketDetailCell.vue"),
    "ticket-participants-avatars": () =>
      import("@/components/app/global/tickets/ticketParticipantsAvatars.vue"),
    "delegates-dropdown-list": () =>
      import("@/components/app/global/delegates/delegatesDropdownList.vue")
  }
})
export default class TicketHeaderClientDetails extends Mixins(
  Context,
  ClientMixin
) {
  // Inject
  @Inject({ from: "ticketProvider" })
  public readonly $ticketData!: () => ITicketProvider;

  @Inject({ from: "ticketProviderMethods" })
  public readonly $ticketMethods!: ITicketProviderMethods;

  // Computed

  public get ticketData() {
    return this.$ticketData();
  }

  public get clientIdentifier() {
    return this.getClientName({
      client: this.$_.get(this.ticketData, "ticket.client"),
      clientId: this.$_.get(this.ticketData, "ticket.client_id")
    });
  }

  public impersonateClient() {
    this.$store.dispatch(
      "auth/admin/impersonateClient",
      this.ticketData.ticket.client_id
    );
  }
}
